import {useNavigate, useParams} from 'react-router-dom';

import {useGetGeoFilter} from '@entities/common';
import {CardBox} from '@shared/components';
import {BaseWidgetLayout, Header} from '@widgets/common';
import {EditGeoFilterOptionForm} from './EditGeoFilterOptionForm';

import {COLOR__WHITE} from '@/theme/colors';

export const EditGeoFilterOptionPage = () => {
  const {id} = useParams<{id: string}>();
  const navigate = useNavigate();
  const {data, isPending, error} = useGetGeoFilter(id ?? '', {enabled: !!id});

  const handleClose = () => {
    navigate(-1);
  };

  if (!id) {
    return 'Invalid GEO category ID';
  }

  return (
    <>
      <Header title={`GEO category ${id}`} mb={1} />

      <BaseWidgetLayout isPending={isPending} error={error}>
        {data && (
          <CardBox bgcolor={COLOR__WHITE}>
            <EditGeoFilterOptionForm geoFilter={data} onClose={handleClose} />
          </CardBox>
        )}
      </BaseWidgetLayout>
    </>
  );
};
